export enum TransactionTypeEnum {
  Deposit = 1,
  Withdraw = 2,
}
